import { token, host } from '../../Connnection';

export default function updateWebsite(dataObject) {

    fetch(`${host}/api/Websites`, {
        method: 'PUT',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataObject)
    })

}